import {defineStore} from 'pinia';
import {computed, ref} from 'vue';
import {getFromServer} from "~/composables/getFromServer.js";

import { useI18n } from 'vue-i18n';


export const useSettingsStore = defineStore('settings', () => {
    const settings = ref([]);
    const translatableSettings = ref([]);
    const components = ref([]);
    const social = ref([]);
    const datalayer = ref([]);
    const promo = ref({});
    const translations = ref({});

    const phone = computed(() => {
        const { t } = useI18n();
        let langKey = 'components.call_us_phone';
        let val = '';

        if (t(langKey) === langKey || !t(langKey)) {
            val = get('settings.contact_phone').split('\r\n')[0];
        } else {
            val = t(langKey);
        }

        return val;
    });

    const phoneOnlyNumbers = computed(() => {
        return '+' + phone.value.replace(/\D/g, '');
    });

    function initData(data) {
        if (data.settings) {
            settings.value = data.settings;
        }
        if (data.components) {
            components.value = data.components;
        }
        if (data.translatable) {
            translatableSettings.value = data.translatable;
        }
        if (data.social) {
            social.value = data.social;
        }
        if (data.promo) {
            promo.value = data.promo;
        }
    }

    async function fetchData() {
        settings.value = await getFromServer('settings');
        components.value = await getFromServer('settings/components');
        await fetchTranslatableSettings();
    }

    async function fetchTranslatableSettings()
    {
        translatableSettings.value = await getFromClient('settings/translatable');
    }

    function hasAccessToComponent(name, strict) {
        const component = getComponent(name);

        return (!component && !strict) || component?.state;
    }

    function get(key, def = '') {
        return settings.value[key] || def;
    }

    function bool(key) {
        return get(key) > 0;
    }

    function translatable(key) {
        return translatableSettings.value[key];
    }

    function getComponent(name) {
        const [componentName, modif] = name.split('.');

        return components.value.find(
            (component) => component.type === 'component' && component.name === componentName && (!component.modif || component.modif === modif)
        )
    }

    function getController(name) {
        return components.value.find((component) => component.type === 'controller' && component.name === name);
    }

    return {
        settings,
        components,
        social,
        datalayer,
        translatableSettings,
        initData,
        get,
        bool,
        translatable,
        getComponent,
        getController,
        fetchData,
        hasAccessToComponent,
        promo,
        phone,
        phoneOnlyNumbers,
        translations
    };
});
